export const interactions = {

  // noEditor: {
  //   model: () => import('../components/interactions/noEditor/model.json'),
  //   editor: () => import('../components/interactions/noEditor/Editor.vue'),
  //   preview: () => import('../components/interactions/noEditor/Preview.vue'),
  // },

  hotSpot: {
    model: () => import('../components/interactions/hotSpot/model.json'),
    editor: () => import('../components/interactions/hotSpot/Editor.vue'),
    preview: () => import('../components/interactions/hotSpot/Preview.vue'),
  },

  graphicChoice: {
    model: () => import('../components/interactions/graphicChoice/model.json'),
    editor: () => import('../components/interactions/graphicChoice/Editor.vue'),
    preview: () => import('../components/interactions/graphicChoice/Preview.vue'),
  },

  geogebra: {
    model: () => import('../components/interactions/geogebra/model.json'),
    editor: () => import('../components/interactions/geogebra/Editor.vue'),
    preview: () => import('../components/interactions/geogebra/Preview.vue'),
  },

  match: {
    model: () => import('../components/interactions/match/model.json'),
    editor: () => import('../components/interactions/match/Editor.vue'),
    preview: () => import('../components/interactions/match/Preview.vue'),
  },

  makingPairs: {
    model: () => import('../components/interactions/makingPairs/model.json'),
    editor: () => import('../components/interactions/makingPairs/Editor.vue'),
    preview: () => import('../components/interactions/makingPairs/Preview.vue'),
  },
    choice: {
      model: () => import('../components/interactions/choice/model.json'),
      editor: () => import('../components/interactions/choice/Editor.vue'),
      preview: () => import('../components/interactions/choice/Preview.vue'),
    },
    message: {
      model: () => import('../components/interactions/message/model.json'),
      editor: () => import('../components/interactions/message/Editor.vue'),
      preview: () => import('../components/interactions/message/Preview.vue'),
    },
    order: {
      model: () => import('../components/interactions/order/model.json'),
      editor: () => import('../components/interactions/order/Editor.vue'),
      preview: () => import('../components/interactions/order/Preview.vue'),
    },
    shortAnswer: {
      model: () => import('../components/interactions/shortAnswer/model.json'),
      editor: () => import('../components/interactions/shortAnswer/Editor.vue'),
      preview: () => import('../components/interactions/shortAnswer/Preview.vue'),
    },
    richText: {
      model: () => import('../components/interactions/richText/model.json'),
      editor: () => import('../components/interactions/richText/Editor.vue'),
      preview: () => import('../components/interactions/richText/Preview.vue'),
    },
    textGaps: {
      model: () => import('../components/interactions/textGaps/model.json'),
      editor: () => import('../components/interactions/textGaps/Editor.vue'),
      preview: () => import('../components/interactions/textGaps/Preview.vue'),
    },
    choiceBlock: {
      model: () => import('../components/interactions/choiceBlock/model.json'),
      editor: () => import('../components/interactions/choiceBlock/Editor.vue'),
      preview: () => import('../components/interactions/choiceBlock/Preview.vue'),
    },
    textPuzzle: {
      model: () => import('../components/interactions/textPuzzle/model.json'),
      editor: () => import('../components/interactions/textPuzzle/Editor.vue'),
      preview: () => import('../components/interactions/textPuzzle/Preview.vue'),
    },
    drawing: {
      model: () => import('../components/interactions/drawing/model.json'),
      editor: () => import('../components/interactions/drawing/Editor.vue'),
      preview: () => import('../components/interactions/drawing/Preview.vue'),
    },
  };
  